import { BsBoxArrowUpRight, BsPencil, BsTrash } from 'react-icons/bs';
import { TableColumnAction } from 'utils/models';
import { RuleItem, RuleTypes } from 'models/rules';
import { useTranslation } from 'react-i18next';
import { RuleDrawer } from 'components/Drawer/RuleDrawer/RuleDrawer';
import { useDrawerContext } from 'context/hooks';
import { GroupSettingsTabs } from 'pages/Settings/Forms/GroupSettings.helpers';
import { useNavigate } from 'react-router-dom';
import { modals } from '@mantine/modals';
import { createConfirmDeleteRuleModal } from 'components/Modal/ConfirmModals';
import { useDeleteRule } from 'hooks/api/rule/useDeleteRule';

export const useActions = (): TableColumnAction<RuleItem>[] => {
  const { t } = useTranslation();
  const { openDrawer } = useDrawerContext();
  const navigate = useNavigate();
  const { mutate: deleteRule } = useDeleteRule();

  const handleDeleteRule = (item: RuleItem) => {
    deleteRule({ item });
  };

  const actions: TableColumnAction<RuleItem>[] = [
    {
      icon: <BsPencil color={'var(--mantine-color-blue-5)'} size={16} />,
      tooltip: t('edit_rule_label'),
      onClick: (item) => {
        openDrawer({
          content: <RuleDrawer />,
          size: '70%',
          title: t('edit_rule_label'),
          detailId: item.id,
        });
      },
      visible: (item) => item.type !== RuleTypes.group,
    },
    {
      icon: <BsBoxArrowUpRight color={'var(--mantine-color-blue-5)'} size={16} />,
      tooltip: t('link_group_label'),
      visible: (item) => item.type === RuleTypes.group,
      onClick: (item) => navigate(`/settings/${item.groupId}/${GroupSettingsTabs.Rules}`),
    },
    {
      icon: <BsTrash color={'var(--mantine-color-red-5)'} size={16} />,
      tooltip: t('delete_label'),
      visible: (item) => item.type !== RuleTypes.group,
      onClick: (item) => modals.openConfirmModal(createConfirmDeleteRuleModal(handleDeleteRule, item)),
    },
  ];

  return actions;
};
